import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = ({ items }) => {
  return (
    <nav className="flex items-center space-x-2 py-md px-xl bg-aug-cream text-sm">
      <Link
        to="/"
        className="flex items-center text-aug-blue hover:text-aug-green transition-colors"
        data-testid="breadcrumb-home"
      >
        <Home className="w-4 h-4" />
      </Link>

      {items.map((item, index) => (
        <React.Fragment key={index}>
          <ChevronRight className="w-4 h-4 text-aug-gray-medium" />
          {item.link ? (
            <Link
              to={item.link}
              className="text-aug-blue hover:text-aug-green transition-colors hover:underline"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-aug-gray-dark font-medium">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;